import { useNavigate } from "react-router-dom";
import {
  Text,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalFooter,
  ModalBody,
  Flex,
  Stack,
  Image,
} from "@chakra-ui/react";
import { cancelGuy } from "../../assets/new-images/modals";

export function CancelModal({
  isOpen,
  onClose,
  title,
  content,
  isLoading,
  navigatePath = -1,
}) {
  const navigate = useNavigate();

  const handleClose = () => {
    onClose();
    navigate(navigatePath);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="3xl">
      <ModalOverlay />
      <ModalContent
        maxW="640px"
        minW="320px"
        minH="328px"
        borderRadius="18px"
        overflow="hidden"
        boxShadow="0px 1px 4px 0px rgba(0, 0, 0, 0.25)"
      >
        <ModalBody p="6">
          <Flex align="center" flexDir={["column-reverse", "row"]} gap="24px">
            <Stack flex={3} align="start" spacing="12px">
              <Text
                as="span"
                fontSize={["14px", "20px"]}
                color="orange.200"
                fontWeight={600}
                lineHeight="normal"
              >
                Atenção!
              </Text>

              <Text
                fontSize={["20px", "28px"]}
                fontWeight={700}
                lineHeight="normal"
              >
                {title}
              </Text>
              {content && <Text lineHeight="24px">{content}</Text>}
            </Stack>
            <Flex flex={2} justify="end">
              <Image src={cancelGuy} alt="" />
            </Flex>
          </Flex>
        </ModalBody>

        <ModalFooter p={0} height="59px">
          <Button
            variant="secondary"
            size="large"
            w="100%"
            height="59px"
            borderRadius={0}
            onClick={onClose}
          >
            Não, continuar
          </Button>
          <Button
            variant="orange"
            size="large"
            w="100%"
            height="59px"
            borderRadius={0}
            isLoading={isLoading}
            onClick={handleClose}
          >
            Sim, cancelar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
